export default __webpack_public_path__ + "static/media/mode-icon.435cca11.svg";